var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.003,
    height: 20.998,
    viewBox: "0 0 21.003 20.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(-842.498 -293.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_30",
    "data-name": "Union 30",
    d: "M15728,967a10,10,0,1,1,10,10A10,10,0,0,1,15728,967Z",
    transform: "translate(-14885 -663)",
    fill: "#fff",
    stroke: "#848484",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-info-lined",
    d: "M12,10.007a.75.75,0,0,0-.75.75v5.5a.75.75,0,1,0,1.5,0v-5.5a.75.75,0,0,0-.75-.75Zm0-3a1,1,0,1,1-1,1A1,1,0,0,1,12,7.006Z",
    transform: "translate(840.994 291.995)",
    fill: "#848484"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.73c59095e2a33f002ce90e05a1dd9085.svg";
export { ForwardRef as ReactComponent };